import { render, staticRenderFns } from "./TranCodeGroupList.vue?vue&type=template&id=21ee763e&scoped=true"
import script from "./TranCodeGroupList.vue?vue&type=script&lang=js"
export * from "./TranCodeGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee763e",
  null
  
)

export default component.exports